import Default from "../Pages/Dashboard/Default";
import ECommerce from "../Pages/Dashboard/ECommerce";
import AceCodeEditor from "../Pages/Miscellaneous/Editor/AceCodeEditor";
import QuillEditor from "../Pages/Miscellaneous/Editor/QuillEditor";
import GoogleMaps from "../Pages/Miscellaneous/Maps/GoogleMaps";
import LeafletMaps from "../Pages/Miscellaneous/Maps/LeafletMaps";
import SupportTicket from "../Pages/Miscellaneous/SupportTicket";
import ApplyJobs from "../Pages/Miscellaneous/JobSearch/ApplyJobs";
import CardsView from "../Pages/Miscellaneous/JobSearch/CardsView";
import JobDetails from "../Pages/Miscellaneous/JobSearch/JobDetails";
import ListView from "../Pages/Miscellaneous/JobSearch/ListView";
import DetailedCourse from "../Pages/Miscellaneous/Learning/DetailedCourse";
import LearningList from "../Pages/Miscellaneous/Learning/LearningList";
import AddPost from "../Pages/Miscellaneous/Blog/AddPost";
import BlogDetails from "../Pages/Miscellaneous/Blog/BlogDetails";
import BlogSingle from "../Pages/Miscellaneous/Blog/BlogSingle";
import Faq from "../Pages/Miscellaneous/FAQ";
import ImageHoverEffects from "../Pages/Miscellaneous/Gallery/ImageHoverEffects";
import MasonryGalleryDescription from "../Pages/Miscellaneous/Gallery/MasonryGalleryDescription";
import Knowledgebase from "../Pages/Miscellaneous/Knowledgebase";
import GalleryDescription from "../Pages/Miscellaneous/Gallery/GalleryDescription";
import GalleryGrid from "../Pages/Miscellaneous/Gallery/GalleryGrid";
import MasonryGallery from "../Pages/Miscellaneous/Gallery/MasonryGallery";
import SamplePage from "../Pages/Pages/SamplePage";
import API from "../Pages/Tables/DataTables/API";
import AdvanceInit from "../Pages/Tables/DataTables/AdvanceInit";
import BasicInit from "../Pages/Tables/DataTables/BasicInit";
import DataSource from "../Pages/Tables/DataTables/DataSource";
import TableComponents from "../Pages/Tables/ReactstrapTables/TableComponents";
import FormWizard2 from "../Pages/Forms/FormLayout/FormWizard2";
import TwoFactor from "../Pages/Forms/FormLayout/TwoFactor";
import BasicTables from "../Pages/Tables/ReactstrapTables/BasicTables";
import FormWizard1 from "../Pages/Forms/FormLayout/FormWizard1";
import Clipboard from "../Pages/Forms/FormWidgets/Clipboard";
import DatePicker from "../Pages/Forms/FormWidgets/Datepicker";
import Switch from "../Pages/Forms/FormWidgets/Switch";
import Touchspin from "../Pages/Forms/FormWidgets/Touchspin";
import Typeahead from "../Pages/Forms/FormWidgets/Typeahead";
import InputGroups from "../Pages/Forms/FormControls/InputGroups";
import InputMask from "../Pages/Forms/FormControls/InputMask";
import MegaOptions from "../Pages/Forms/FormControls/MegaOptions";
import BaseInputs from "../Pages/Forms/FormControls/BaseInputs";
import CheckboxAndRadio from "../Pages/Forms/FormControls/CheckboxAndRadio";
import ApexChart from "../Pages/Charts/ApexChart";
import ChartJsChart from "../Pages/Charts/ChartJsChart";
import GoogleChart from "../Pages/Charts/GoogleChart";
import FormValidation from "../Pages/Forms/FormControls/FormValidation";
import DefaultStyle from "../Pages/Buttons/DefaultStyle";
import FeatherIcons from "../Pages/Icons/FeatherIcons";
import IcoIcon from "../Pages/Icons/IcoIcon";
import ThemifyIcon from "../Pages/Icons/ThemifyIcon";
import WhetherIcon from "../Pages/Icons/WhetherIcon";
import CreativeCard from "../Pages/BonusUi/CreativeCard";
import Timeline from "../Pages/BonusUi/Timeline";
import FlagIcons from "../Pages/Icons/FlagIcons";
import FontAwesomeIcon from "../Pages/Icons/FontAwesomeIcon";
import BasicCard from "../Pages/BonusUi/BasicCard";
import Breadcrumb from "../Pages/BonusUi/Breadcrumb";
import ImageCropper from "../Pages/BonusUi/ImageCropper";
import RangeSlider from "../Pages/BonusUi/RangeSlider";
import OwlCarousel from "../Pages/BonusUi/OwlCarousel";
import Pagination from "../Pages/BonusUi/Pagination";
import Ribbons from "../Pages/BonusUi/Ribbons";
import Dropzone from "../Pages/BonusUi/Dropzone";
import Rating from "../Pages/BonusUi/Rating";
import SweetAlert from "../Pages/BonusUi/SweetAlert";
import Tour from "../Pages/BonusUi/Tour";
import Scrollable from "../Pages/BonusUi/Scrollable";
import Toasts from "../Pages/BonusUi/Toasts";
import TreeView from "../Pages/BonusUi/TreeView";
import Lists from "../Pages/UiKits/Lists";
import Tabs from "../Pages/UiKits/Tabs";
import Accordion from "../Pages/UiKits/Accordion";
import Dropdown from "../Pages/UiKits/Dropdown";
import Alert from "../Pages/UiKits/Alert";
import Popover from "../Pages/UiKits/Popover";
import Tooltip from "../Pages/UiKits/Tooltip";
import Typography from "../Pages/UiKits/Typography";
import Project from "../Pages/Dashboard/Project";
import General from "../Pages/Widgets/General";
import Avatars from "../Pages/UiKits/Avatars";
import HelperClasses from "../Pages/UiKits/HelperClasses";
import Modal from "../Pages/UiKits/Modal";
import Grid from "../Pages/UiKits/Grid";
import Progress from "../Pages/UiKits/Progress";
import TagAndPills from "../Pages/UiKits/Tag&Pills";
import SearchResult from "../Pages/Applications/SearchResult";
import Calendar from "../Pages/Applications/Calendar";
import SocialApp from "../Pages/Applications/SocialApp";
import Contacts from "../Pages/Applications/Contacts";
import Tasks from "../Pages/Applications/Tasks";
import EditProfile from "../Pages/Applications/Users/UsersEdit";
import UserCards from "../Pages/Applications/Users/UserCards";
import Bookmarks from "../Pages/Applications/Bookmarks";
import ToDo from "../Pages/Applications/ToDo";
import PrivateChat from "../Pages/Applications/Chat/PrivateChat";
import GroupChat from "../Pages/Applications/Chat/GroupChat";
import UserProfile from "../Pages/Applications/Users/UserProfile";
import Invoice5 from "../Pages/Applications/ECommerce/Invoices/Invoice5";
import Invoice6 from "../Pages/Applications/ECommerce/Invoices/Invoice6";
import LetterBox from "../Pages/Applications/LetterBox";
import Wishlist from "../Pages/Applications/ECommerce/Wishlist";
import Checkout from "../Pages/Applications/ECommerce/Checkout";
import Pricing from "../Pages/Applications/ECommerce/Pricing";
import Invoice1 from "../Pages/Applications/ECommerce/Invoices/Invoice1";
import Invoice2 from "../Pages/Applications/ECommerce/Invoices/Invoice2";
import Invoice3 from "../Pages/Applications/ECommerce/Invoices/Invoice3";
import Invoice4 from "../Pages/Applications/ECommerce/Invoices/Invoice4";
import CategoryPage from "../Pages/Applications/ECommerce/CategoryPage";
import ProductList from "../Pages/Applications/ECommerce/ProductList";
import ProductPage from "../Pages/Applications/ECommerce/ProductPage";
import PaymentDetails from "../Pages/Applications/ECommerce/PaymentDetails";
import OrderHistory from "../Pages/Applications/ECommerce/OrderHistory";
import Cart from "../Pages/Applications/ECommerce/Cart";
import AddProduct from "../Pages/Applications/ECommerce/AddProduct";
import Product from "../Pages/Applications/ECommerce/Product";
import Chart from "../Pages/Widgets/Chart";
import ProjectList from "../Pages/Applications/Project/ProjectList";
import ProjectCreate from "../Pages/Applications/Project/ProjectCreate";
import FileManager from "../Pages/Applications/FileManager";
import JsGridTable from "../Pages/Tables/JsGridTable";
import CountriesFlag from "../Pages/settings/Countries";
import TrailRequests from "../Pages/settings/Company/TrailRequest";
import SignIn from "../Auth";
import PlansAndPricingPage from "../Pages/settings/PlansAndPricing";
import CreatePlansAndPricingPage from "../Pages/settings/PlansAndPricing/createPlan";
import DataTableExample from "../Pages/settings/TableExample/TableExample";
import RegisteredCompanyListingPage from "../Pages/settings/Company/companyList";
import RegisteredCompanyCreatingPage from "../Pages/settings/Company/companyCreate";
import HolidayPage from "../Pages/Paper/holiday";
import path from "path";
import ProjectSelection from "../Pages/ProjectSelection";
import TableDummy from "../Pages/TableDummy/TableDumy";
import UserGroupList from "../Pages/UserGroups/list/userGroupList";
import TableBroker from "../Pages/Broker/TableBroker";
import TableClearingAccount from "../Pages/ClearingAccount/TableClearingAccount";
import TableClearer from "../Pages/Clearer/TableClear";
import TableBook from "../Pages/Book/TableBook";
import TableStrategy from "../Pages/Strategy/TableStrategy";
import TableDerivative from "../Pages/Derivative/TableDerivative";
import TableHoliday from "../Pages/Holiday/TableHoliday";
import TableContractType from "../Pages/ContractType/TableContactType";
import TableUnit from "../Pages/Unit/TableUnit";
import TableCounterpartyCompanies from "../Pages/CounterpartyCompanies/TableCounterpartyCompanies";
import TableClearerRates from "../Pages/ClearerRates/TableClearerRates";
import TableBrokerage from "../Pages/Brokerage/TableBrokerage";
import TableApiSetting from "../Pages/ApiSettings/TableApiSetting";
import TableContract from "../Pages/Contract/TableContract";
import TablePaperTrading from "../Pages/Trading/PaperTrading/TablePaperTrading";
import ReconciliationTable from "../Pages/Trading/PaperTrading/reconciliationTable";
import TablePaperPosition from "../Pages/Trading/PaperPosition/TablePaperPosition";
import TablePaperExposure from "../Pages/Trading/PaperExposure/TablePaperExposure";
import TablePaperTradingHistory from "../Pages/Trading/PaperTradingHistory/TablePaperTradingHistory";
import APITrades from "../Pages/APITrades/APITrades/TableAPITrades";
import TableSettlementPrice from "../Pages/Trading/SettlementPrice/TableSettlementPrice";
import TableContractForm from "../Pages/ContractForm";
import ContractHomeTableForm from "../Pages/ContractForm/index";
import CompanyDetails from "../Pages/settings/Company/CompanyDetails";
import CompanyUserManagement from "../Pages/users/CompanyUserManagement";
import UserGroupCreate from "../Pages/UserGroups/create/UserGroupCreate";
import CompanyUserList from "../Pages/users/list/companyUserList";
import PnlSummaryPage from "../Pages/PnlSummary";
import HistoricalVar from "../Pages/RiskCalculator/HistoryVar/HistoricalVar";
import CompanyEditPage from "../Pages/settings/Company/companyEdit/CompanyEditPage";
import AdminErrorPage from "../Pages/AdminErrorLog/main";
import ErrorLogDetails from "../Pages/AdminErrorLog/ErrorLogDetails";
import AuditLogDetails from "../Pages/AutoHistoryLog/AuditLog";
import FileUploads from "../Pages/FileUploads/FileUploads";
import Futuresltd from "../Pages/Trading/FuturesLtd/TableFuturesltd";
import CompanyPlanUpgrade from "../Pages/settings/Company/companyPlanUpgrade";
import CompanyUserUpgrade from "../Pages/settings/Company/companyUserUpgrade";
import UpgradeUser from "../Pages/users/upgradeUser";
import PaymentSuccessPage from "../Pages/users/upgradeUser/paymentSuccess";
import AuditLogDetails2 from "../Pages/AutoHistoryLog/AuditLogDetails2";
import SecurityDefnitions from "../Pages/Trading/Security Defnitions/SecurityDefnitions";
import PnlSummary from "../Pages/Report/PnlSummary";
import ExchangeAndClearing from "../Pages/Trading/Exchange and clearing/ExchangeAndClearing";
import BrokerAge from "../Pages/Report/BrokerAge";
import TradeCapture from "../Pages/Trading/PaperTrading/TradeCapture";
import OrganizationTrades from "../Pages/Trading/PaperTrading/OrganizationTrades";
import CounterpartyTrades from "../Pages/Trading/PaperTrading/CounterpartyTrades";
import InitialMargin from "../Pages/Report/InitialMargin";
import FileUpload from "../Pages/Trading/PaperTrading/FileUpload";
import IceExhcnageTrades from "../Pages/Trading/PaperTrading/TradeCaptureAPI/IceExhcnageTrades";
import TradeCaptureApi from "../Pages/Trading/PaperTrading/TradeCaptureApi";
import TtTrades from "../Pages/Trading/PaperTrading/TtTrades";
import ApiBrokerSettings from "../Pages/ApiSettings/ApiBrokerSettings";
import PnlSummaryView2 from "../Pages/Report/PnlSummaryView2";
import ReconciliationTableCounterParty from "../Pages/Trading/PaperTrading/ReConceliationCounterParty";
import TradeUploadPage from "../Pages/Trading/PaperTrading/FileUpload/TradeUploadPage";
import TableProfitShareByBook from "../Pages/ProfitShareByBook/TableBook"
import CustomerMarkUpMetrix from "../Pages/CustomerMarkupMetrix/CustomerMarkUpMetrix";
import ReconciliationContractMapping from "../Pages/BornSheet/ContractMap/ReconceliationContractMapping";
import ReconciliationCustomerMapping from "../Pages/BornSheet/CustomerMap/RecponceliationCustomerMapping";
import ReconciliationAutomationPage from "../Pages/BornSheet/Reconautomation/Reconautomation";
import TableCostType from "../Pages/CostType/TableCostType"
import CostObjectForm from "../Pages/CostObject";
import TableCostStatus from "../Pages/CostStatus/TableCostStatus"
import Cashflow from "../Pages/Cashflow/index"

// import PNLSummary from "../Pages/Report/TableReport";

// import ContractHomeTableForm from "../Pages/ContractForm";
export const routes = [
  { path: `${process.env.PUBLIC_URL}/`, element: <SignIn /> },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/typography`,
    element: <Typography />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/avatars`,
    element: <Avatars />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/helper_classes`,
    element: <HelperClasses />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/grid`,
    element: <Grid />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/tag_pills`,
    element: <TagAndPills />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/progress_bar`,
    element: <Progress />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/alert`,
    element: <Alert />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/popover`,
    element: <Popover />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/tooltip`,
    element: <Tooltip />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/modal`,
    element: <Modal />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/dropdown`,
    element: <Dropdown />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/accordion`,
    element: <Accordion />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/tabs`,
    element: <Tabs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/lists`,
    element: <Lists />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/scrollable`,
    element: <Scrollable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/tree`,
    element: <TreeView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/toasts`,
    element: <Toasts />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/rating`,
    element: <Rating />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/dropzone`,
    element: <Dropzone />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/tour`,
    element: <Tour />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/sweet_alert_2`,
    element: <SweetAlert />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/add_products`,
    element: <AddProduct />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/product`,
    element: <Product />,
  },
  {
    path: `${process.env.PUBLIC_URL}/widgets/chart_widget`,
    element: <Chart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/project/project_list`,
    element: <ProjectList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/project/create_project`,
    element: <ProjectCreate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/file_manager`,
    element: <FileManager />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/owl_carousel`,
    element: <OwlCarousel />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/ribbons`,
    element: <Ribbons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/pagination`,
    element: <Pagination />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/breadcrumb`,
    element: <Breadcrumb />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/range_slider`,
    element: <RangeSlider />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/image_cropper`,
    element: <ImageCropper />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/basic_card`,
    element: <BasicCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/themify_icon`,
    element: <ThemifyIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/ico_icon`,
    element: <IcoIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/feather_icon`,
    element: <FeatherIcons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/whether_icon`,
    element: <WhetherIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/buttons`,
    element: <DefaultStyle />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/creative_card`,
    element: <CreativeCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/timeline`,
    element: <Timeline />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/flag_icon`,
    element: <FlagIcons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/font_awesome`,
    element: <FontAwesomeIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/category_page`,
    element: <CategoryPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/product_list`,
    element: <ProductList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/product_page`,
    element: <ProductPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/payment_details`,
    element: <PaymentDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/order_history`,
    element: <OrderHistory />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/cart`,
    element: <Cart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/add_products`,
    element: <AddProduct />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/product`,
    element: <Product />,
  },
  {
    path: `${process.env.PUBLIC_URL}/widgets/chart_widget`,
    element: <Chart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/project/project_list`,
    element: <ProjectList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/project/create_project`,
    element: <ProjectCreate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/file_manager`,
    element: <FileManager />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/owl_carousel`,
    element: <OwlCarousel />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/ribbons`,
    element: <Ribbons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/pagination`,
    element: <Pagination />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/breadcrumb`,
    element: <Breadcrumb />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/range_slider`,
    element: <RangeSlider />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/image_cropper`,
    element: <ImageCropper />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/basic_card`,
    element: <BasicCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/themify_icon`,
    element: <ThemifyIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/ico_icon`,
    element: <IcoIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/feather_icon`,
    element: <FeatherIcons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/whether_icon`,
    element: <WhetherIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/buttons`,
    element: <DefaultStyle />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/creative_card`,
    element: <CreativeCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/bonus_ui/timeline`,
    element: <Timeline />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/flag_icon`,
    element: <FlagIcons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/icons/font_awesome`,
    element: <FontAwesomeIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/charts/chart_apex`,
    element: <ApexChart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/charts/chart_google`,
    element: <GoogleChart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/charts/chartjs`,
    element: <ChartJsChart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/form_validation`,
    element: <FormValidation />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/base_input`,
    element: <BaseInputs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/radio_checkbox_control`,
    element: <CheckboxAndRadio />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_2`,
    element: <FormWizard2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/two_factor`,
    element: <TwoFactor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/basic_table`,
    element: <BasicTables />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/clipboard`,
    element: <Clipboard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_1`,
    element: <FormWizard1 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/datepicker`,
    element: <DatePicker />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/touchspin`,
    element: <Touchspin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/switch`,
    element: <Switch />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/typeahead`,
    element: <Typeahead />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_group`,
    element: <InputGroups />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_mask`,
    element: <InputMask />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/mega_options`,
    element: <MegaOptions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/contacts`,
    element: <Contacts />,
  },
  { path: `${process.env.PUBLIC_URL}/applications/task`, element: <Tasks /> },
  {
    path: `${process.env.PUBLIC_URL}/applications/users/edit_profile`,
    element: <EditProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/users/user_cards`,
    element: <UserCards />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/bookmark`,
    element: <Bookmarks />,
  },
  { path: `${process.env.PUBLIC_URL}/applications/to_do`, element: <ToDo /> },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_group`,
    element: <InputGroups />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_mask`,
    element: <InputMask />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/mega_options`,
    element: <MegaOptions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/search`,
    element: <SearchResult />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/table_components`,
    element: <TableComponents />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/data_tables/basic_init`,
    element: <BasicInit />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/data_tables/advance_init`,
    element: <AdvanceInit />,
  },
  { path: `${process.env.PUBLIC_URL}/table/data_tables/api`, element: <API /> },
  {
    path: `${process.env.PUBLIC_URL}/table/data_tables/data_sources`,
    element: <DataSource />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/sample_page`,
    element: <SamplePage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery`,
    element: <GalleryGrid />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery_description`,
    element: <GalleryDescription />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry_gallery`,
    element: <MasonryGallery />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/calendar_basic`,
    element: <Calendar />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/social_app`,
    element: <SocialApp />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_mask`,
    element: <InputMask />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/mega_options`,
    element: <MegaOptions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/radio_checkbox_control`,
    element: <CheckboxAndRadio />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_2`,
    element: <FormWizard2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/two_factor`,
    element: <TwoFactor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/basic_table`,
    element: <BasicTables />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/clipboard`,
    element: <Clipboard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_1`,
    element: <FormWizard1 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/datepicker`,
    element: <DatePicker />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/touchspin`,
    element: <Touchspin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/switch`,
    element: <Switch />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/typeahead`,
    element: <Typeahead />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_group`,
    element: <InputGroups />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_mask`,
    element: <InputMask />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/mega_options`,
    element: <MegaOptions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/radio_checkbox_control`,
    element: <CheckboxAndRadio />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/chat/chat_private`,
    element: <PrivateChat />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/chat/chat_group`,
    element: <GroupChat />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/users/user_profile`,
    element: <UserProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_2`,
    element: <FormWizard2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/two_factor`,
    element: <TwoFactor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/basic_table`,
    element: <BasicTables />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/radio_checkbox_control`,
    element: <CheckboxAndRadio />,
  },
  {
    path: `${process.env.PUBLIC_URL}/invoice/invoice_5`,
    element: <Invoice5 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/invoice/invoice_6`,
    element: <Invoice6 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/email/letter_box`,
    element: <LetterBox />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/radio_checkbox_control`,
    element: <CheckboxAndRadio />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_2`,
    element: <FormWizard2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/two_factor`,
    element: <TwoFactor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/basic_table`,
    element: <BasicTables />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/js_grid_tables`,
    element: <JsGridTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/wishlist`,
    element: <Wishlist />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/checkout`,
    element: <Checkout />,
  },
  {
    path: `${process.env.PUBLIC_URL}/applications/ecommerce/pricing`,
    element: <Pricing />,
  },
  {
    path: `${process.env.PUBLIC_URL}/invoice/invoice_1`,
    element: <Invoice1 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/invoice/invoice_2`,
    element: <Invoice2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/invoice/invoice_3`,
    element: <Invoice3 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/invoice/invoice_4`,
    element: <Invoice4 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_2`,
    element: <FormWizard2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/two_factor`,
    element: <TwoFactor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/basic_table`,
    element: <BasicTables />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/clipboard`,
    element: <Clipboard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_1`,
    element: <FormWizard1 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/datepicker`,
    element: <DatePicker />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/touchspin`,
    element: <Touchspin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/switch`,
    element: <Switch />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_widgets/typeahead`,
    element: <Typeahead />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_group`,
    element: <InputGroups />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/input_mask`,
    element: <InputMask />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/form_controls/mega_options`,
    element: <MegaOptions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/table_components`,
    element: <TableComponents />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/data_tables/basic_init`,
    element: <BasicInit />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/data_tables/advance_init`,
    element: <AdvanceInit />,
  },
  { path: `${process.env.PUBLIC_URL}/table/data_tables/api`, element: <API /> },
  {
    path: `${process.env.PUBLIC_URL}/table/data_tables/data_sources`,
    element: <DataSource />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/sample_page`,
    element: <SamplePage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery`,
    element: <GalleryGrid />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery_description`,
    element: <GalleryDescription />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry_gallery`,
    element: <MasonryGallery />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/maps/google_map`,
    element: <GoogleMaps />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/maps/leaflet_map`,
    element: <LeafletMaps />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/editors/ace_code_editor`,
    element: <AceCodeEditor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/editors/quill_editor`,
    element: <QuillEditor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/support_ticket`,
    element: <SupportTicket />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_cards_view`,
    element: <CardsView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_list_view`,
    element: <ListView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_details`,
    element: <JobDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_apply`,
    element: <ApplyJobs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/learning/learning_list_view`,
    element: <LearningList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/learning/course_details`,
    element: <DetailedCourse />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry_gallery_description`,
    element: <MasonryGalleryDescription />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/gallery_hover`,
    element: <ImageHoverEffects />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/blog/blog_detail`,
    element: <BlogDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/blog/blog_single`,
    element: <BlogSingle />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/blog/add_post`,
    element: <AddPost />,
  },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/faq`, element: <Faq /> },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/knowledgebase`,
    element: <Knowledgebase />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery`,
    element: <GalleryGrid />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery_description`,
    element: <GalleryDescription />,
  },
  {
    path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry_gallery`,
    element: <MasonryGallery />,
  },
  {
    path: `${process.env.PUBLIC_URL}/components/ui_kits/typography`,
    element: <Typography />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,
    element: <ECommerce />,
  },
  { path: `${process.env.PUBLIC_URL}/dashboard/project`, element: <Project /> },
  {
    path: `${process.env.PUBLIC_URL}/widgets/general_widget`,
    element: <General />,
  },
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, element: <Default /> },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,
    element: <ECommerce />,
  },

  {
    path: `${process.env.PUBLIC_URL}/settings/company/trail-request`,
    element: <TrailRequests />,
    appName: "settings",
    SourceName: "trail_request",
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/plans-and-pricing/`,
    element: <PlansAndPricingPage />,
    appName: "settings",
    SourceName: "plans_and_pricing",
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/plans-and-pricing/create-plans`,
    element: <CreatePlansAndPricingPage />,
    appName: "settings",
    SourceName: "create_plans_and_pricing",
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/plans-and-pricing/data-table`,
    element: <DataTableExample />,
    appName: "settings",
    SourceName: "create_plans_and_pricing",
  },

  {
    path: `${process.env.PUBLIC_URL}/settings/company/list-register-company`,
    element: <RegisteredCompanyListingPage />,
    appName: "settings",
    SourceName: "plans_and_pricing",
  },

  {
    path: `${process.env.PUBLIC_URL}/settings/company/list-register-company/:id`,
    element: <CompanyDetails />,
  },

  {
    path: `${process.env.PUBLIC_URL}/settings/company/upgrade-plan/:id`,
    element: <CompanyPlanUpgrade />,
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/company/upgrade-user/:id`,
    element: <CompanyUserUpgrade />,
  },
  {
    path: `${process.env.PUBLIC_URL}/company/upgrade-user/`,
    element: <UpgradeUser />,
  },
  // { path: `${process.env.PUBLIC_URL}/user-upgrade/payment-success/verification/:id}`, element: <PaymentSuccessPage /> },

  {
    path: `${process.env.PUBLIC_URL}/settings/company/register-company`,
    element: <RegisteredCompanyCreatingPage />,
    appName: "settings",
    SourceName: "plans_and_pricing",
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/company/edit-registered-company/:id`,
    element: <CompanyEditPage />,
    appName: "settings",
    SourceName: "compny_edit",
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/countries`,
    element: <CountriesFlag />,
  },

  { path: `${process.env.PUBLIC_URL}/table/dummy`, element: <TableDummy /> },

  {
    path: `${process.env.PUBLIC_URL}/paper/holidays`,
    element: <HolidayPage />,
  },

  {
    path: `${process.env.PUBLIC_URL}/data-table/broker`,
    element: <TableBroker />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/contract-mapping`,
    element: <ReconciliationContractMapping />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/reconciliation-automation`,
    element: <ReconciliationAutomationPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/customer-mapping`,
    element: <ReconciliationCustomerMapping />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/clearer`,
    element: <TableClearer />,
  },
  { path: `${process.env.PUBLIC_URL}/data-table/book`, element: <TableBook /> },
  { path: `${process.env.PUBLIC_URL}/data-table/profitshare-by-book`, element: <TableProfitShareByBook /> },
  { path: `${process.env.PUBLIC_URL}/data-table/cost-type`, element: <TableCostType /> },
  // { path: `${process.env.PUBLIC_URL}/data-table/cost-status`, element: <TableCostStatus /> },
  {
    path: `${process.env.PUBLIC_URL}/data-table/strategy`,
    element: <TableStrategy />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/derivative`,
    element: <TableDerivative />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/holiday`,
    element: <TableHoliday />,
  },
  // { path: `${process.env.PUBLIC_URL}/data-table/type`, element: <TableType /> },
  // { path: `${process.env.PUBLIC_URL}/data-table/unit`, element: <TableUnit /> },
  {
    path: `${process.env.PUBLIC_URL}/data-table/counterparty-companies`,
    element: <TableCounterpartyCompanies />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/strategy`,
    element: <TableStrategy />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/derivative`,
    element: <TableDerivative />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/holiday`,
    element: <TableHoliday />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/contract-type`,
    element: <TableContractType />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/units`,
    element: <TableUnit />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/counterparty-companies`,
    element: <TableCounterpartyCompanies />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/clearer-rates`,
    element: <TableClearerRates />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/brokerage`,
    element: <TableBrokerage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/api-setting`,
    element: <TableApiSetting />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/contract`,
    element: <TableContract />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/api-broker-setting`,
    element: <ApiBrokerSettings />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/contract-form`,
    element: <TableContractForm />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/Clearing-account`,
    element: <TableClearingAccount />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/contract-form`,
    element: <ContractHomeTableForm />,
  },
  {
    path: `${process.env.PUBLIC_URL}/data-table/file-uploads`,
    element: <FileUploads />,
  },

  {
    path: `${process.env.PUBLIC_URL}/trading/paper-trading`,
    element: <TablePaperTrading />,
  },
  {
    path: `${process.env.PUBLIC_URL}/trading/paper-position`,
    element: <TablePaperPosition />,
  },
  {
    path: `${process.env.PUBLIC_URL}/trading/paper-exposure`,
    element: <TablePaperExposure />,
  },
  {
    path: `${process.env.PUBLIC_URL}/trading/paper-trading-history`,
    element: <TablePaperTradingHistory />,
  },
  {
    path: `${process.env.PUBLIC_URL}/APITrades/API-Trades`,
    element: <APITrades />,
  },
  {
    path: `${process.env.PUBLIC_URL}/Settings/file-uploads`,
    element: <FileUpload />,
  },
  {
    path: `${process.env.PUBLIC_URL}/Settings/customer-markup-matrix`,
    element: <CustomerMarkUpMetrix />,
  },
  {
    path: `${process.env.PUBLIC_URL}/trading/settlement-price`,
    element: <TableSettlementPrice />,
  },
  { path: `${process.env.PUBLIC_URL}/futuresltd`, element: <Futuresltd /> },
  {
    path: `${process.env.PUBLIC_URL}/trading/trade-reconciliation`,
    element: <ReconciliationTable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/trading/trade-reconciliation-counterparty`,
    element: <ReconciliationTableCounterParty />,
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/security-definitions`,
    element: <SecurityDefnitions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/exchange-clearings`,
    element: <ExchangeAndClearing />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/pnl-summary/view-1`,
    element: <PnlSummary />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/pnl-summary/view-2`,
    element: <PnlSummaryView2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/initial-margin`,
    element: <InitialMargin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/reports/brokerage`,
    element: <BrokerAge />,
  },
  {
    path: `${process.env.PUBLIC_URL}/trade-upload`,
    element: <TradeUploadPage />
  },

  // {path: `/project-selection`, element: <ProjectSelection/>}

  // User management

  {
    path: `${process.env.PUBLIC_URL}/company/user-management`,
    element: <CompanyUserManagement />,
  },
  {
    path: `${process.env.PUBLIC_URL}/company/user-management/list`,
    element: <CompanyUserList />,
  },

  //Trade Capture
  {
    path: `${process.env.PUBLIC_URL}/paper/trade-capture/manual`,
    element: <TradeCapture />,
  },
  {
    path: `${process.env.PUBLIC_URL}/paper/trade-capture/api/ice-exchange`,
    element: <IceExhcnageTrades/>,
  },
  {
    path: `${process.env.PUBLIC_URL}/paper/trade-capture/api/tt-trades`,
    // element: <TtTrades/>,
    element: <TradeCaptureApi />,
  },
  {
    path: `${process.env.PUBLIC_URL}/paper/deal-bottler/organization-trades`,
    element: <OrganizationTrades />,
  },
  {
    path: `${process.env.PUBLIC_URL}/paper/deal-bottler/counterparty-trades`,
    element: <CounterpartyTrades />,
  },
  {
    path: `${process.env.PUBLIC_URL}/paper/cost-booking`,
    element: <CostObjectForm />,
  },
  {
    path: `${process.env.PUBLIC_URL}/paper/cashflow`,
    element: <Cashflow />,
  },

  //group
  {
    path: `${process.env.PUBLIC_URL}/company/group-management/create`,
    element: <UserGroupCreate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/company/group-management/list`,
    element: <UserGroupList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/report/pnl-summary`,
    element: <PnlSummaryPage />,
  },

  //Risk Calculator

  {
    path: `${process.env.PUBLIC_URL}/risk-calculator/historical-var`,
    element: <HistoricalVar />,
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/admin-error-log`,
    element: <AdminErrorPage />,
  },

  {
    path: `${process.env.PUBLIC_URL}/settings/log/history/:name`,
    element: <AuditLogDetails />,
    appName: "settings",
    SourceName: "compny_edit",
  },
  {
    path: `${process.env.PUBLIC_URL}/settings/log/history/:name/:id`,
    element: <AuditLogDetails2 />,
    appName: "settings",
    SourceName: "log_details2",
  },

  {
    path: `${process.env.PUBLIC_URL}/settings/log/details/:id`,
    element: <ErrorLogDetails />,
    appName: "settings",
    SourceName: "compny_edit",
  },
];
